export default __webpack_public_path__ + "static/headstand-fullheadstand-3-982ebbcaa292ff4322cb597bbe51445d.jpg";